/** Énumération des possibles valeurs de la propriété `autocapitalize` des champs de formulaires qui l'acceptent. */
export enum EAutocapitalize {
	none = "none",
	characters = "characters",
	sentences = "sentences",
	words = "words"
}